(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const initCartPage = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('[data-cart-page-form]');
      if (!form) return;
      const status = root.querySelector('[data-cart-page-status]');
      const quantityInputs = [...form.querySelectorAll('[data-cart-page-quantity]')];
      const note = form.querySelector('[name="note"]');
      const requestedDate = form.querySelector('[name="attributes[Requested delivery date]"]');
      let saving;
      const saveCart = () => {
        if (saving) return saving;
        const updates = {};
        quantityInputs.forEach((input) => {
          updates[input.dataset.lineKey] = Math.max(0, Math.floor(Number(input.value) || 0));
        });
        const attributes = {};
        if (requestedDate) attributes['Requested delivery date'] = requestedDate.value;
        const payload = { updates, note: note?.value || '' };
        if (requestedDate) payload.attributes = attributes;
        status.textContent = root.dataset.savingLabel;
        saving = fetch(root.dataset.cartUpdateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        }).then((response) => {
          if (!response.ok) throw new Error(root.dataset.errorLabel);
          return response.json();
        }).then((cart) => {
          status.textContent = root.dataset.savedLabel;
          document.dispatchEvent(new CustomEvent('sundae:cart-changed', { detail: { cart } }));
          return cart;
        }).catch((error) => {
          status.textContent = error.message || root.dataset.errorLabel;
          throw error;
        }).finally(() => { saving = null; });
        return saving;
      };
      quantityInputs.forEach((input) => input.addEventListener('change', async () => {
        try {
          await saveCart();
          window.location.reload();
        } catch (error) {}
      }));
      [note, requestedDate].filter(Boolean).forEach((field) => field.addEventListener('change', () => { saveCart().catch(() => {}); }));
    };
    const initAllCartPages = (scope = document) => scope.querySelectorAll('[data-cart-page]').forEach(initCartPage);
    initAllCartPages();
    document.addEventListener('shopify:section:load', (event) => initAllCartPages(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const initHeader = (header) => {
      if (header.dataset.initialized === 'true') return;
      header.dataset.initialized = 'true';
      const menu = header.querySelector('[data-header-menu]');
      if (!menu) return;
      const closeMenu = () => {
        menu.removeAttribute('open');
        document.body.classList.remove('sundae-menu-open');
      };
      menu.querySelectorAll('[data-close-menu]').forEach((button) => button.addEventListener('click', closeMenu));
      menu.addEventListener('toggle', () => document.body.classList.toggle('sundae-menu-open', menu.open));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) closeMenu();
      });
    };
    const initAllHeaders = (scope = document) => scope.querySelectorAll('[data-sundae-header]').forEach(initHeader);
    initAllHeaders();
    document.addEventListener('shopify:section:load', (event) => initAllHeaders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const initProduct = (section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      const variant = section.querySelector('[data-product-variant]');
      if (!variant) return;
      variant.addEventListener('change', () => {
        const option = variant.selectedOptions[0];
        const available = option.dataset.available === 'true';
        const price = section.querySelector('[data-product-price]');
        if (price) price.textContent = option.dataset.price;
        section.querySelectorAll('[data-product-action]').forEach((button) => {
          button.disabled = !available;
          button.textContent = available ? button.dataset.label : button.dataset.soldLabel;
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      });
    };
    const initAllProducts = (scope = document) => scope.querySelectorAll('[data-product-section]').forEach(initProduct);
    initAllProducts();
    document.addEventListener('shopify:section:load', (event) => initAllProducts(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sundae-box-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBuilder = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const sizeButtons = [...root.querySelectorAll('[data-box-size]')];
      const slotsElement = root.querySelector('[data-box-slots]');
      const progressElement = root.querySelector('[data-box-progress]');
      const summaryElement = root.querySelector('[data-box-summary]');
      const summaryList = root.querySelector('[data-box-summary-list]');
      const statusElement = root.querySelector('[data-box-status]');
      const addButton = root.querySelector('[data-add-box]');
      const buyButton = root.querySelector('[data-buy-box]');
      const clearButton = root.querySelector('[data-clear-box]');
      const dialog = root.querySelector('[data-flavour-dialog]');
      const closeButton = root.querySelector('[data-close-picker]');
      const removeButton = root.querySelector('[data-remove-slot]');
      const choices = [...root.querySelectorAll('[data-cookie-choice]')];
      const currencyCode = root.dataset.currencyCode || 'INR';
      const discountPercent = Number(root.dataset.discountPercent) || 0;
      const discountCode = root.dataset.discountCode.trim();
      const subtotalElement = root.querySelector('[data-box-subtotal]');
      const savingElement = root.querySelector('[data-box-saving]');
      const totalElement = root.querySelector('[data-box-total]');
      const actionButtons = [addButton, buyButton];
      const hasCookies = root.dataset.hasCookies === 'true' && choices.length > 0;
      let boxSize = Number(root.dataset.defaultSize) || 6;
      let selections = Array(boxSize).fill(null);
      let activeSlot = 0;

      const interpolate = (template, values) => Object.entries(values).reduce((text, entry) => text.replace(`[${entry[0]}]`, entry[1]), template);
      const formatMoney = (cents) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: currencyCode, maximumFractionDigits: 0 }).format(cents / 100);
      const calculatePricing = () => {
        const subtotal = selections.filter(Boolean).reduce((sum, cookie) => sum + cookie.priceCents, 0);
        const saving = Math.round(subtotal * discountPercent / 100);
        return { subtotal, saving, total: subtotal - saving };
      };
      const discountRedirect = (destination) => {
        if (!discountCode) return destination;
        const rootUrl = root.dataset.rootUrl.endsWith('/') ? root.dataset.rootUrl : `${root.dataset.rootUrl}/`;
        return `${rootUrl}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(destination)}`;
      };

      const openPicker = (index) => {
        if (!dialog || !hasCookies) return;
        activeSlot = index;
        const selectedCookie = selections[index];
        choices.forEach((choice) => {
          const current = selectedCookie && choice.dataset.variantId === selectedCookie.variantId;
          choice.classList.toggle('is-current', Boolean(current));
          choice.setAttribute('aria-pressed', current ? 'true' : 'false');
        });
        if (removeButton) removeButton.hidden = !selectedCookie;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        const firstChoice = dialog.querySelector('[data-cookie-choice]');
        if (firstChoice) firstChoice.focus();
      };

      const closePicker = () => {
        if (!dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      };

      const renderSummary = () => {
        const grouped = new Map();
        selections.filter(Boolean).forEach((cookie) => {
          const existing = grouped.get(cookie.variantId);
          if (existing) existing.quantity += 1;
          else grouped.set(cookie.variantId, { ...cookie, quantity: 1 });
        });
        summaryList.replaceChildren();
        grouped.forEach((cookie) => {
          const item = document.createElement('li');
          const title = document.createElement('span');
          const price = document.createElement('span');
          title.textContent = `${cookie.title} × ${cookie.quantity}`;
          price.textContent = formatMoney(cookie.priceCents * cookie.quantity);
          item.append(title, price);
          summaryList.append(item);
        });
        summaryElement.hidden = grouped.size === 0;
        const pricing = calculatePricing();
        subtotalElement.textContent = formatMoney(pricing.subtotal);
        savingElement.textContent = `−${formatMoney(pricing.saving)}`;
        totalElement.textContent = formatMoney(pricing.total);
      };

      const render = (animateIndex = -1) => {
        slotsElement.replaceChildren();
        selections.forEach((cookie, index) => {
          const slot = document.createElement('button');
          const number = document.createElement('span');
          slot.type = 'button';
          slot.className = 'sundae-builder__slot';
          slot.disabled = !hasCookies;
          number.className = 'sundae-builder__slot-number';
          number.textContent = index + 1;
          slot.append(number);

          if (cookie) {
            const imageWrap = document.createElement('span');
            const title = document.createElement('span');
            imageWrap.className = `sundae-builder__slot-image${index === animateIndex ? ' is-arriving' : ''}`;
            title.className = 'sundae-builder__slot-title';
            title.textContent = cookie.title;
            if (cookie.imageUrl) {
              const image = document.createElement('img');
              image.src = cookie.imageUrl;
              image.alt = '';
              imageWrap.append(image);
            } else {
              const placeholder = document.createElement('span');
              placeholder.className = 'sundae-builder__cookie-placeholder';
              imageWrap.append(placeholder);
            }
            slot.setAttribute('aria-label', interpolate(root.dataset.replaceSlotTemplate, { number: index + 1, title: cookie.title }));
            slot.append(imageWrap, title);
          } else {
            const placeholder = document.createElement('span');
            const title = document.createElement('span');
            placeholder.className = 'sundae-builder__slot-placeholder';
            placeholder.textContent = '+';
            placeholder.setAttribute('aria-hidden', 'true');
            title.className = 'sundae-builder__slot-title';
            title.textContent = interpolate(root.dataset.emptySlotTemplate, { number: index + 1 });
            slot.setAttribute('aria-label', title.textContent);
            slot.append(placeholder, title);
          }
          slot.addEventListener('click', () => openPicker(index));
          slotsElement.append(slot);
        });

        const selectedCount = selections.filter(Boolean).length;
        const remaining = boxSize - selectedCount;
        progressElement.textContent = interpolate(root.dataset.progressTemplate, { count: selectedCount, total: boxSize });
        sizeButtons.forEach((button) => {
          const selected = Number(button.dataset.boxSize) === boxSize;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        actionButtons.forEach((button) => { button.disabled = remaining !== 0 || !hasCookies; });
        clearButton.disabled = selectedCount === 0;
        const pricing = calculatePricing();
        addButton.textContent = remaining === 0 ? `${root.dataset.addLabel} — ${formatMoney(pricing.total)}` : root.dataset.addLabel;
        buyButton.textContent = remaining === 0 ? `${root.dataset.buyLabel} — ${formatMoney(pricing.total)}` : root.dataset.buyLabel;
        statusElement.textContent = selectedCount > 0 && remaining > 0 ? interpolate(root.dataset.remainingTemplate, { count: remaining }) : '';
        renderSummary();
      };

      sizeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const nextSize = Number(button.dataset.boxSize);
          if (nextSize === boxSize) return;
          selections = selections.slice(0, nextSize);
          while (selections.length < nextSize) selections.push(null);
          boxSize = nextSize;
          statusElement.textContent = '';
          render();
        });
      });

      choices.forEach((choice) => {
        choice.addEventListener('click', () => {
          const cookie = {
            variantId: choice.dataset.variantId,
            title: choice.dataset.cookieTitle,
            priceCents: Number(choice.dataset.priceCents),
            imageUrl: choice.dataset.imageUrl
          };
          selections[activeSlot] = cookie;
          closePicker();
          render(activeSlot);
        });
      });

      if (closeButton) closeButton.addEventListener('click', closePicker);
      if (dialog) dialog.addEventListener('click', (event) => { if (event.target === dialog) closePicker(); });
      if (removeButton) removeButton.addEventListener('click', () => {
        selections[activeSlot] = null;
        closePicker();
        render();
      });
      clearButton.addEventListener('click', () => {
        selections = Array(boxSize).fill(null);
        statusElement.textContent = '';
        render();
      });

      const submitBox = async (action, triggerButton) => {
        if (selections.some((cookie) => !cookie)) return;
        actionButtons.forEach((button) => { button.disabled = true; });
        triggerButton.textContent = action === 'checkout' ? root.dataset.buyingLabel : root.dataset.addingLabel;
        statusElement.textContent = '';
        const boxId = `SUNDAE-${Date.now()}`;
        const grouped = new Map();
        selections.forEach((cookie) => {
          const existing = grouped.get(cookie.variantId);
          if (existing) existing.quantity += 1;
          else grouped.set(cookie.variantId, { id: Number(cookie.variantId), quantity: 1 });
        });
        const items = [...grouped.values()].map((item) => ({
          ...item,
          properties: { 'Box size': `${boxSize} cookies`, '_SUNDAE box ID': boxId }
        }));
        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('cart');
          if (action === 'checkout') {
            window.location.assign(discountRedirect(root.dataset.checkoutUrl));
            return;
          }
          if (discountCode) {
            await fetch(discountRedirect(root.dataset.cartUrl), { credentials: 'same-origin' }).catch(() => {});
          }
          render();
          statusElement.textContent = root.dataset.addedLabel;
          document.dispatchEvent(new CustomEvent('sundae:cart-added', { detail: { message: root.dataset.addedLabel } }));
        } catch (error) {
          render();
          statusElement.textContent = root.dataset.errorLabel;
        }
      };

      addButton.addEventListener('click', () => submitBox('cart', addButton));
      buyButton.addEventListener('click', () => submitBox('checkout', buyButton));

      render();
    };

    const initAllBuilders = (scope = document) => scope.querySelectorAll('[data-box-builder]').forEach(initBuilder);
    initAllBuilders();
    document.addEventListener('shopify:section:load', (event) => initAllBuilders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sundae-entrance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initEntrance = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const door = root.querySelector('[data-entrance-door]');
      const outside = root.querySelector('[data-entrance-outside]');
      const inside = root.querySelector('[data-entrance-inside]');
      const birds = root.querySelector('[data-entrance-birds]');
      const doorAudio = root.querySelector('[data-entrance-door-audio]');
      const interiorAudio = root.querySelector('[data-entrance-interior-audio]');
      const entranceVideos = [...root.querySelectorAll('.sundae-entrance__video video')];
      const keepVideoMuted = root.dataset.videoMuted !== 'false';
      const hour = new Date().getHours();
      root.dataset.period = hour >= 18 || hour < 6 ? 'night' : 'day';
      entranceVideos.forEach((video) => {
        video.muted = true;
        video.play().catch(() => {});
      });
      if (!keepVideoMuted) {
        root.addEventListener('pointerdown', () => {
          entranceVideos.filter((video) => video.offsetParent !== null).forEach((video) => {
            video.muted = false;
            video.volume = 0.35;
            video.play().catch(() => {});
          });
        }, { once: true });
      }
      const finishEntrance = () => {
        root.classList.remove('is-entering');
        root.classList.add('is-entered');
        document.body.classList.add('sundae-entered');
        outside.setAttribute('aria-hidden', 'true');
        inside.setAttribute('aria-hidden', 'false');
        inside.removeAttribute('inert');
        entranceVideos.forEach((video) => video.pause());
      };
      if (root.dataset.rememberSession === 'true' && sessionStorage.getItem('sundae-entered') === 'true') {
        finishEntrance();
        return;
      }
      if (birds) {
        birds.volume = 0.22;
        birds.play().catch(() => {});
      }
      door.addEventListener('click', () => {
        if (root.classList.contains('is-entering')) return;
        root.classList.add('is-entering');
        document.body.classList.add('sundae-entered');
        if (birds) birds.pause();
        entranceVideos.forEach((video) => {
          if (keepVideoMuted) video.pause();
          else window.setTimeout(() => video.pause(), 650);
        });
        if (doorAudio) {
          doorAudio.currentTime = 0;
          doorAudio.play().catch(() => {});
        }
        if (interiorAudio) {
          interiorAudio.volume = 0;
          interiorAudio.play().catch(() => {});
          window.setTimeout(() => { interiorAudio.volume = 0.18; }, 700);
        }
        if (root.dataset.rememberSession === 'true') sessionStorage.setItem('sundae-entered', 'true');
        window.setTimeout(finishEntrance, 1050);
      });
    };
    const initAllEntrances = (scope = document) => scope.querySelectorAll('[data-sundae-entrance]').forEach(initEntrance);
    initAllEntrances();
    document.addEventListener('shopify:section:load', (event) => initAllEntrances(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sundae-hamper-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHamper = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const productCards = [...root.querySelectorAll('[data-hamper-product]')];
      const addButton = root.querySelector('[data-add-hamper]');
      const buyButton = root.querySelector('[data-buy-hamper]');
      const selectionElement = root.querySelector('[data-hamper-selection]');
      const subtotalElement = root.querySelector('[data-hamper-subtotal]');
      const savingElement = root.querySelector('[data-hamper-saving]');
      const totalElement = root.querySelector('[data-hamper-total]');
      const statusElement = root.querySelector('[data-hamper-status]');
      const actionButtons = [addButton, buyButton];
      const discountPercent = Number(root.dataset.discountPercent) || 0;
      const discountCode = root.dataset.discountCode.trim();
      const currencyCode = root.dataset.currencyCode || 'INR';
      const formatMoney = (cents) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: currencyCode, maximumFractionDigits: 0 }).format(cents / 100);
      const interpolate = (template, value) => template.replace('[count]', value);
      const variantState = (card) => {
        const control = card.querySelector('[data-hamper-variant]');
        const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
        return {
          id: Number(control.value),
          price: Number(option.dataset.priceCents) || 0,
          available: option.dataset.available === 'true'
        };
      };
      const selectedItems = () => productCards.map((card) => {
        const variant = variantState(card);
        const quantity = Math.max(0, Math.floor(Number(card.querySelector('[data-hamper-quantity]').value) || 0));
        return { ...variant, quantity };
      }).filter((item) => item.available && item.quantity > 0);
      const totals = () => {
        const items = selectedItems();
        const count = items.reduce((sum, item) => sum + item.quantity, 0);
        const subtotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
        const saving = Math.round(subtotal * discountPercent / 100);
        return { items, count, subtotal, saving, total: subtotal - saving };
      };
      const render = () => {
        productCards.forEach((card) => {
          const variant = variantState(card);
          const input = card.querySelector('[data-hamper-quantity]');
          const quantity = Math.max(0, Math.floor(Number(input.value) || 0));
          input.value = quantity;
          card.classList.toggle('is-selected', quantity > 0);
          card.querySelector('[data-hamper-minus]').disabled = quantity === 0;
          card.querySelector('[data-hamper-plus]').disabled = !variant.available;
          card.querySelector('[data-hamper-price]').textContent = formatMoney(variant.price);
        });
        const pricing = totals();
        selectionElement.textContent = interpolate(root.dataset.selectionTemplate, pricing.count);
        subtotalElement.textContent = formatMoney(pricing.subtotal);
        savingElement.textContent = `−${formatMoney(pricing.saving)}`;
        totalElement.textContent = formatMoney(pricing.total);
        actionButtons.forEach((button) => { button.disabled = pricing.count === 0; });
        addButton.textContent = pricing.count ? `${root.dataset.addLabel} — ${formatMoney(pricing.total)}` : root.dataset.addLabel;
        buyButton.textContent = pricing.count ? `${root.dataset.buyLabel} — ${formatMoney(pricing.total)}` : root.dataset.buyLabel;
      };
      productCards.forEach((card) => {
        const input = card.querySelector('[data-hamper-quantity]');
        card.querySelector('[data-hamper-minus]').addEventListener('click', () => {
          input.value = Math.max(0, Number(input.value) - 1);
          statusElement.textContent = '';
          render();
        });
        card.querySelector('[data-hamper-plus]').addEventListener('click', () => {
          input.value = Math.max(0, Number(input.value)) + 1;
          statusElement.textContent = '';
          render();
        });
        input.addEventListener('input', () => {
          statusElement.textContent = '';
          render();
        });
        const variantControl = card.querySelector('select[data-hamper-variant]');
        if (variantControl) variantControl.addEventListener('change', render);
      });
      const discountRedirect = (destination) => {
        if (!discountCode) return destination;
        const rootUrl = root.dataset.rootUrl.endsWith('/') ? root.dataset.rootUrl : `${root.dataset.rootUrl}/`;
        return `${rootUrl}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(destination)}`;
      };
      const submitHamper = async (action, triggerButton) => {
        const pricing = totals();
        if (!pricing.items.length) return;
        actionButtons.forEach((button) => { button.disabled = true; });
        triggerButton.textContent = action === 'checkout' ? root.dataset.buyingLabel : root.dataset.addingLabel;
        statusElement.textContent = '';
        const hamperId = `SUNDAE-HAMPER-${Date.now()}`;
        const items = pricing.items.map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: { 'Hamper': 'SUNDAE hamper', '_SUNDAE hamper ID': hamperId }
        }));
        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('cart');
          if (action === 'checkout') {
            window.location.assign(discountRedirect(root.dataset.checkoutUrl));
            return;
          }
          if (discountCode) await fetch(discountRedirect(root.dataset.cartUrl), { credentials: 'same-origin' }).catch(() => {});
          render();
          statusElement.textContent = root.dataset.addedLabel;
          document.dispatchEvent(new CustomEvent('sundae:cart-added', { detail: { message: root.dataset.addedLabel } }));
        } catch (error) {
          render();
          statusElement.textContent = root.dataset.errorLabel;
        }
      };
      addButton.addEventListener('click', () => submitHamper('cart', addButton));
      buyButton.addEventListener('click', () => submitHamper('checkout', buyButton));
      render();
    };
    const initAllHampers = (scope = document) => scope.querySelectorAll('[data-hamper-builder]').forEach(initHamper);
    initAllHampers();
    document.addEventListener('shopify:section:load', (event) => initAllHampers(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
